import ProjectTemplates from 'components/pages/admin/project-templates/project-templates'

export default ProjectTemplates
